import { render, staticRenderFns } from "./ContainerText.vue?vue&type=template&id=04876d5b&scoped=true"
import script from "./ContainerText.vue?vue&type=script&lang=js"
export * from "./ContainerText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04876d5b",
  null
  
)

export default component.exports